import * as React from "react";
function XxlIcon() {
    return React.createElement("path", { d: "M26.8464 23.969L17.1387 14.242L18.7694 12.6113L30.1078 23.969L18.7694 35.3074L17.1387 33.6766L26.8464 23.969Z", fill: "currentColor" });
}
export default XxlIcon;
//# sourceMappingURL=Xxl.js.map